module.exports = __webpack_public_path__ + "img/snowflake-03.db1873d2.png";